var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-club" },
    [
      _c("club-summary", { staticClass: "account-club__summary" }),
      _c(
        "h3",
        { staticClass: "account-club__title  account-club__title-calendar" },
        [_vm._v("\n    График начисления бонусов\n  ")]
      ),
      _c("club-points-calendar", { staticClass: "account-club__calendar" }),
      _c(
        "h3",
        { staticClass: "account-club__title account-club__title-history" },
        [_vm._v("\n    История операций с бонусами\n  ")]
      ),
      _c("club-points-history", { staticClass: "account-club__history" }),
      _c(
        "div",
        { staticClass: "account-club__hint" },
        [
          _vm._v(
            "\n    С вопросами обращайтесь в службу поддержки пользователей FUNDAY по почте\n    "
          ),
          _c(
            "ui-link",
            { attrs: { href: "mailto:helpme@fundayshop.com", color: "black" } },
            [_vm._v("\n      helpme@fundayshop.com\n    ")]
          ),
          _vm._v("\n    или по телефону "),
          _c(
            "ui-link",
            { attrs: { href: "tel:8 800 770-01-01", color: "black" } },
            [_vm._v("\n      8 800 770-01-01\n    ")]
          ),
          _vm._v("  (по России бесплатно), с 7:00 до 22:00 (мск)\n  ")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }